import { ContentCodeStatus, Game } from "@riot-private/commerce-contentcodes-client/lib";

// utilities for mapping specific content codes to game contexts for themes and error messages
type GameSpecificCodeValidationStatus =
  | typeof ContentCodeStatus.AccountMissingLol
  | typeof ContentCodeStatus.AccountMissingLor
  | typeof ContentCodeStatus.AccountMissingValorant
  | typeof ContentCodeStatus.AccountMissingWr;

export const gameSpecificCodeValidationStatusMap: Record<GameSpecificCodeValidationStatus, Game> = {
  [ContentCodeStatus.AccountMissingLol]: Game.Lol,
  [ContentCodeStatus.AccountMissingLor]: Game.Lor,
  [ContentCodeStatus.AccountMissingValorant]: Game.Val,
  [ContentCodeStatus.AccountMissingWr]: Game.Wr,
};

export const isGameSpecificCodeValidationStatus = (
  status?: ContentCodeStatus,
): status is GameSpecificCodeValidationStatus => {
  return !!status && Object.hasOwn(gameSpecificCodeValidationStatusMap, status);
};
